import { useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";

// Public shortlink the flyer QR + AMOA email links point at:
//   https://arcadeops.net/r/AZIZ-2026?v=<venue-slug>            → /?ref=…&venue=…&src=qr   (unchanged)
//   https://arcadeops.net/r/FG-XXXXXXXXXX?v=amoa&to=fortune      → /fortune?ref=…&venue=amoa&src=qr
// `to` is whitelisted (fortune | aog); anything else lands on the homepage as before. Every open is one scan row
// (no dedupe). The redirect fires first; the beacon is fire-and-forget. public/index.html has the same fast path.
const DESTINATIONS = { fortune: "/fortune", aog: "/aog" };

export function shortlinkTarget(code, params) {
  const venue = params.get("v") || params.get("venue") || null;
  const to = (params.get("to") || "").toLowerCase();
  const src = params.get("src") || "qr";
  const search = new URLSearchParams({ ref: code });
  if (venue) search.set("venue", venue);
  search.set("src", src);
  return { venue, to: to || null, src, url: `${DESTINATIONS[to] || "/"}?${search.toString()}` };
}

export default function QrRedirect() {
  const { code = "AZIZ-2026" } = useParams();
  const [params] = useSearchParams();

  useEffect(() => {
    const { venue, to, src, url } = shortlinkTarget(code, params);
    window.location.replace(url);
    if (window.__qrScanSent) return;
    try {
      const body = JSON.stringify({ code, venue, to, src, referer: document.referrer || null });
      const beaconUrl = `${api.defaults.baseURL}/analytics/scan`;
      if (navigator.sendBeacon) {
        navigator.sendBeacon(beaconUrl, new Blob([body], { type: "text/plain" }));
      } else {
        fetch(beaconUrl, { method: "POST", body, keepalive: true, headers: { "Content-Type": "text/plain" } }).catch(() => {});
      }
    } catch { /* the scan tracker must never affect the redirect */ }
  }, [code, params]);

  return (
    <div className="min-h-screen bg-background text-foreground flex items-center justify-center">
      <div className="text-center">
        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#f5c243] mb-2">Loading Fortune Games</div>
        <div className="text-sm text-muted-foreground">One sec…</div>
      </div>
    </div>
  );
}
